import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DataResponse, ServerResponse } from "models/common/responseObjects";
import { DashboardsFilterQuery } from "models/filters/dashboards/DashboardsFilterQuery";
import { DashboardData } from "models/storeModels/DashboardData";
import { DashboardsApi } from "apis/DashboardsApi";
import { ReactNode } from "react";
import { millisecond, year } from "ag-grid-enterprise/dist/lib/ag-charts-community/util/time";
import { DashboardWidgetsFilterQuery } from "models/filters/dashboards/DashboardWidgetsFilterQuery";


export const getDashboardStores = createAsyncThunk("dashboardSlice/getDashboardStores", async (params?: DashboardsFilterQuery) => {
    const response = await DashboardsApi.Search(params ? params : {});
    return response.data;
});


export const getDashboardWidgetsForStore = createAsyncThunk(
	"dashboardSlice/getDashboardWidgetsForStore",
	async (params?: DashboardWidgetsFilterQuery) => {
		const response = await DashboardsApi.SearchWidgets(params ? params : {});
		return response.data;
	}
);

function ApplyCutoffMainGraph(index: number, data: number): number | null {
    return index < new Date().getMonth() ? data : null;
}

function ApplyCutoffDrillDown(index: number, data: number): number | null {
    return index < new Date().getMonth() ? data : null;
}

function CalculateSales(state: StateType, action: any) {

    let filteredStores = state.storeData.stores.filter((i: any) => state.selectedStores.includes(i.storeId));

    //RESET!
    state.sales.otc = 0;
    state.sales.script = 0;
    state.sales.total = 0;

    state.sales.prevOtc = 0;
    state.sales.prevScript = 0;
    state.sales.prevTotal = 0;

    state.topSales = [];
    state.topSalesMax = 0;

    for (let storeIndex = 0; storeIndex < filteredStores.length; storeIndex++) {
        const store = filteredStores[storeIndex];

        if (store.response?.data) {

            let newEntry = {
                name: store.storeName,
                value: 0
            };

            const currentYear = new Date().getFullYear();

            if (state.period === currentYear.toString()) {
                state.sales.otc += store.response.data.salesOtc?.year3.values.reduce((a, b) => a + b, 0) || 0;
                state.sales.script += store.response.data.salesScript?.year3.values.reduce((a, b) => a + b, 0) || 0;

                state.sales.prevOtc += store.response.data.salesOtc?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.sales.prevScript += store.response.data.salesScript?.year2.values.reduce((a, b) => a + b, 0) || 0;

                state.sales.message = "Since last year";
            } else if (state.period === (currentYear - 1).toString()) {
                state.sales.otc += store.response.data.salesOtc?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.sales.script += store.response.data.salesScript?.year2.values.reduce((a, b) => a + b, 0) || 0;

                state.sales.prevOtc += store.response.data.salesOtc?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.sales.prevScript += store.response.data.salesScript?.year1.values.reduce((a, b) => a + b, 0) || 0;

                state.sales.message = "Since last year";
            } else if (state.period === (currentYear - 2).toString()) {
                state.sales.otc += store.response.data.salesOtc?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.sales.script += store.response.data.salesScript?.year1.values.reduce((a, b) => a + b, 0) || 0;

                state.sales.prevOtc += store.response.data.salesOtc?.year0.values.reduce((a, b) => a + b, 0) || 0;
                state.sales.prevScript += store.response.data.salesScript?.year0.values.reduce((a, b) => a + b, 0) || 0;

                state.sales.message = "Since last year";
            } else if (state.period === "Month") {
                state.sales.otc += store.response.data.salesOtc?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.sales.script += store.response.data.salesScript?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;

                state.sales.prevOtc += store.response.data.salesOtc?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.sales.prevScript += store.response.data.salesScript?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;

                state.sales.message = "Since last month";
            } else if (state.period === "Week") {
                state.sales.otc += store.response.data.salesOtc?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.sales.script += store.response.data.salesScript?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;

                state.sales.prevOtc += store.response.data.salesOtc?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.sales.prevScript += store.response.data.salesScript?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;

                state.sales.message = "Since last week";
            } else if (state.period === "Day") {
                state.sales.otc += store.response.data.salesOtc?.today.values.reduce((a, b) => a + b, 0) || 0;
                state.sales.script += store.response.data.salesScript?.today.values.reduce((a, b) => a + b, 0) || 0;

                state.sales.prevOtc += store.response.data.salesOtc?.yesterday.values.reduce((a, b) => a + b, 0) || 0;
                state.sales.prevScript += store.response.data.salesScript?.yesterday.values.reduce((a, b) => a + b, 0) || 0;

                state.sales.message = "Since yesterday";
            }

            state.sales.total = state.sales.otc + state.sales.script;
            state.sales.prevTotal = state.sales.prevOtc + state.sales.prevScript;

            newEntry.value = state.sales.total;

            state.topSales.push(newEntry);

            if (newEntry.value > state.topSalesMax) state.topSalesMax = newEntry.value;
        }
    }
}

function CalculateScripts(state: StateType, action: any) {

    let filteredStores = state.storeData.stores.filter((i: any) => state.selectedStores.includes(i.storeId));

    //RESET!
    state.scripts.paper = 0;
    state.scripts.paperless = 0;
    state.scripts.owing = 0;
    state.scripts.total = 0;

    state.scripts.prevPaper = 0;
    state.scripts.prevPaperless = 0;
    state.scripts.prevOwing = 0;
    state.scripts.prevTotal = 0;

    for (let storeIndex = 0; storeIndex < filteredStores.length; storeIndex++) {
        const store = filteredStores[storeIndex];

        if (store.response?.data) {

            const currentYear = new Date().getFullYear();

            if (state.period === currentYear.toString()) {
                state.scripts.paper += store.response.data.scriptsPaper?.year3.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.paperless += store.response.data.scriptsPaperless?.year3.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.owing += store.response.data.scriptsOwing?.year3.values.reduce((a, b) => a + b, 0) || 0;

                state.scripts.prevPaper += store.response.data.scriptsPaper?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.prevPaperless += store.response.data.scriptsPaperless?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.prevOwing += store.response.data.scriptsOwing?.year2.values.reduce((a, b) => a + b, 0) || 0;

                state.scripts.message = "Since last year";
            } else if (state.period === (currentYear - 1).toString()) {
                state.scripts.paper += store.response.data.scriptsPaper?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.paperless += store.response.data.scriptsPaperless?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.owing += store.response.data.scriptsOwing?.year2.values.reduce((a, b) => a + b, 0) || 0;

                state.scripts.prevPaper += store.response.data.scriptsPaper?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.prevPaperless += store.response.data.scriptsPaperless?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.prevOwing += store.response.data.scriptsOwing?.year1.values.reduce((a, b) => a + b, 0) || 0;

                state.scripts.message = "Since last year";
            } else if (state.period === (currentYear - 2).toString()) {
                state.scripts.paper += store.response.data.scriptsPaper?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.paperless += store.response.data.scriptsPaperless?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.owing += store.response.data.scriptsOwing?.year1.values.reduce((a, b) => a + b, 0) || 0;

                state.scripts.prevPaper += store.response.data.scriptsPaper?.year0.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.prevPaperless += store.response.data.scriptsPaperless?.year0.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.prevOwing += store.response.data.scriptsOwing?.year0.values.reduce((a, b) => a + b, 0) || 0;

                state.scripts.message = "Since last year";
            } else if (state.period === "Month") {
                state.scripts.paper += store.response.data.scriptsPaper?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.paperless += store.response.data.scriptsPaperless?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.owing += store.response.data.scriptsOwing?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;

                state.scripts.prevPaper += store.response.data.scriptsPaper?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.prevPaperless += store.response.data.scriptsPaperless?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.prevOwing += store.response.data.scriptsOwing?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;

                state.scripts.message = "Since last month";
            } else if (state.period === "Week") {
                state.scripts.paper += store.response.data.scriptsPaper?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.paperless += store.response.data.scriptsPaperless?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.owing += store.response.data.scriptsOwing?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;

                state.scripts.prevPaper += store.response.data.scriptsPaper?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.prevPaperless += store.response.data.scriptsPaperless?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.prevOwing += store.response.data.scriptsOwing?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;

                state.scripts.message = "Since last week";
            } else if (state.period === "Day") {
                state.scripts.paper += store.response.data.scriptsPaper?.today.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.paperless += store.response.data.scriptsPaperless?.today.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.owing += store.response.data.scriptsOwing?.today.values.reduce((a, b) => a + b, 0) || 0;

                state.scripts.prevPaper += store.response.data.scriptsPaper?.yesterday.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.prevPaperless += store.response.data.scriptsPaperless?.yesterday.values.reduce((a, b) => a + b, 0) || 0;
                state.scripts.prevOwing += store.response.data.scriptsOwing?.yesterday.values.reduce((a, b) => a + b, 0) || 0;

                state.scripts.message = "Since yesterday";
            }

            state.scripts.total = state.scripts.paper + state.scripts.paperless + state.scripts.owing;
            state.scripts.prevTotal = state.scripts.prevPaper + state.scripts.prevPaperless + state.scripts.prevOwing;
        }
    }
}

function CalculateGrossProfit(state: StateType, action: any) {

    let filteredStores = state.storeData.stores.filter((i: any) => state.selectedStores.includes(i.storeId));

    //RESET!
    state.grossProfit.otc = 0;
    state.grossProfit.script = 0;
    state.grossProfit.total = 0;

    state.grossProfit.prevOtc = 0;
    state.grossProfit.prevScript = 0;
    state.grossProfit.prevTotal = 0;

    for (let storeIndex = 0; storeIndex < filteredStores.length; storeIndex++) {
        const store = filteredStores[storeIndex];

        const currentYear = new Date().getFullYear();

        if (store.response?.data) {

            if (state.period === currentYear.toString()) {
                state.grossProfit.otc += store.response.data.grossProfitOtc?.year3.values.reduce((a, b) => a + b, 0) || 0;
                state.grossProfit.script += store.response.data.grossProfitScript?.year3.values.reduce((a, b) => a + b, 0) || 0;

                state.grossProfit.prevOtc += store.response.data.grossProfitOtc?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.grossProfit.prevScript += store.response.data.grossProfitScript?.year2.values.reduce((a, b) => a + b, 0) || 0;

                state.grossProfit.message = "Since last year";
            } else if (state.period === (currentYear - 1).toString()) {
                state.grossProfit.otc += store.response.data.grossProfitOtc?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.grossProfit.script += store.response.data.grossProfitScript?.year2.values.reduce((a, b) => a + b, 0) || 0;

                state.grossProfit.prevOtc += store.response.data.grossProfitOtc?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.grossProfit.prevScript += store.response.data.grossProfitScript?.year1.values.reduce((a, b) => a + b, 0) || 0;

                state.grossProfit.message = "Since last year";
            } else if (state.period === (currentYear - 2).toString()) {
                state.grossProfit.otc += store.response.data.grossProfitOtc?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.grossProfit.script += store.response.data.grossProfitScript?.year1.values.reduce((a, b) => a + b, 0) || 0;

                state.grossProfit.prevOtc += store.response.data.grossProfitOtc?.year0.values.reduce((a, b) => a + b, 0) || 0;
                state.grossProfit.prevScript += store.response.data.grossProfitScript?.year0.values.reduce((a, b) => a + b, 0) || 0;

                state.grossProfit.message = "Since last year";
            } else if (state.period === "Month") {
                state.grossProfit.otc += store.response.data.grossProfitOtc?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.grossProfit.script += store.response.data.grossProfitScript?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;

                state.grossProfit.prevOtc += store.response.data.grossProfitOtc?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.grossProfit.prevScript += store.response.data.grossProfitScript?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;

                state.grossProfit.message = "Since last month";
            } else if (state.period === "Week") {
                state.grossProfit.otc += store.response.data.grossProfitOtc?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.grossProfit.script += store.response.data.grossProfitScript?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;

                state.grossProfit.prevOtc += store.response.data.grossProfitOtc?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.grossProfit.prevScript += store.response.data.grossProfitScript?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;

                state.grossProfit.message = "Since last week";
            } else if (state.period === "Day") {
                state.grossProfit.otc += store.response.data.grossProfitOtc?.today.values.reduce((a, b) => a + b, 0) || 0;
                state.grossProfit.script += store.response.data.grossProfitScript?.today.values.reduce((a, b) => a + b, 0) || 0;

                state.grossProfit.prevOtc += store.response.data.grossProfitOtc?.yesterday.values.reduce((a, b) => a + b, 0) || 0;
                state.grossProfit.prevScript += store.response.data.grossProfitScript?.yesterday.values.reduce((a, b) => a + b, 0) || 0;

                state.grossProfit.message = "Since yesterday";
            }

            state.grossProfit.total = state.grossProfit.otc + state.grossProfit.script;
            state.grossProfit.prevTotal = state.grossProfit.prevOtc + state.grossProfit.prevScript;
        }
    }
}

function CalclatePreferredBrand(state: StateType, action: any) {

    let filteredStores = state.storeData.stores.filter((i: any) => state.selectedStores.includes(i.storeId));

    //RESET!
    state.preferredBrand.count = 0;
    state.preferredBrand.total = 0;
    state.preferredBrand.moneyLost = 0;

    state.preferredBrand.prevCount = 0;
    state.preferredBrand.prevTotal = 0;
    state.preferredBrand.prevMoneyLost = 0;

    state.preferredBrand.middle = [];
    state.preferredBrand.message = [];


    for (let storeIndex = 0; storeIndex < filteredStores.length; storeIndex++) {
        const store = filteredStores[storeIndex];

        const currentYear = new Date().getFullYear();

        if (store.response?.data) {

            if (state.period === currentYear.toString()) {
                state.preferredBrand.count += store.response.data.optimalBrandCount?.year3.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.total += store.response.data.optimalBrandTotal?.year3.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.moneyLost += store.response.data.optimalBrandLost?.year3.values.reduce((a, b) => a + b, 0) || 0;

                state.preferredBrand.prevCount += store.response.data.optimalBrandCount?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.prevTotal += store.response.data.optimalBrandTotal?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.prevMoneyLost += store.response.data.optimalBrandLost?.year2.values.reduce((a, b) => a + b, 0) || 0;
            } else if (state.period === (currentYear - 1).toString()) {
                state.preferredBrand.count += store.response.data.optimalBrandCount?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.total += store.response.data.optimalBrandTotal?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.moneyLost += store.response.data.optimalBrandLost?.year2.values.reduce((a, b) => a + b, 0) || 0;

                state.preferredBrand.prevCount += store.response.data.optimalBrandCount?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.prevTotal += store.response.data.optimalBrandTotal?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.prevMoneyLost += store.response.data.optimalBrandLost?.year1.values.reduce((a, b) => a + b, 0) || 0;
            } else if (state.period === (currentYear - 2).toString()) {
                state.preferredBrand.count += store.response.data.optimalBrandCount?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.total += store.response.data.optimalBrandTotal?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.moneyLost += store.response.data.optimalBrandLost?.year1.values.reduce((a, b) => a + b, 0) || 0;

                state.preferredBrand.prevCount += store.response.data.optimalBrandCount?.year0.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.prevTotal += store.response.data.optimalBrandTotal?.year0.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.prevMoneyLost += store.response.data.optimalBrandLost?.year0.values.reduce((a, b) => a + b, 0) || 0;
            } else if (state.period === "Month") {
                state.preferredBrand.count += store.response.data.optimalBrandCount?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.total += store.response.data.optimalBrandTotal?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.moneyLost += store.response.data.optimalBrandLost?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;

                state.preferredBrand.prevCount += store.response.data.optimalBrandCount?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.prevTotal += store.response.data.optimalBrandTotal?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.prevMoneyLost += store.response.data.optimalBrandLost?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;
            } else if (state.period === "Week") {
                state.preferredBrand.count += store.response.data.optimalBrandCount?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.total += store.response.data.optimalBrandTotal?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.moneyLost += store.response.data.optimalBrandLost?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;

                state.preferredBrand.prevCount += store.response.data.optimalBrandCount?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.prevTotal += store.response.data.optimalBrandTotal?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.prevMoneyLost += store.response.data.optimalBrandLost?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;
            } else if (state.period === "Day") {
                state.preferredBrand.count += store.response.data.optimalBrandCount?.today.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.total += store.response.data.optimalBrandTotal?.today.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.moneyLost += store.response.data.optimalBrandLost?.today.values.reduce((a, b) => a + b, 0) || 0;

                state.preferredBrand.prevCount += store.response.data.optimalBrandCount?.yesterday.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.prevTotal += store.response.data.optimalBrandTotal?.yesterday.values.reduce((a, b) => a + b, 0) || 0;
                state.preferredBrand.prevMoneyLost += store.response.data.optimalBrandLost?.yesterday.values.reduce((a, b) => a + b, 0) || 0;
            }
            state.preferredBrand.message[0] = Number(state.preferredBrand.count).toLocaleString(undefined, { maximumFractionDigits: 2 }) + "/" + Number(state.preferredBrand.total).toLocaleString(undefined, { maximumFractionDigits: 2 }) + " scripts";
            state.preferredBrand.message[1] = state.preferredBrand.moneyLost.toFixed(2);
        }
    }
}

function CalculateMainGraph(state: StateType, action: any) {
    let filteredStores = state.storeData.stores.filter((i: any) => state.selectedStores.includes(i.storeId));
    //RESET!
    state.comparisonGraph.axis = [];
    state.comparisonGraph.data = [];

    const period = state.period == undefined? action.payload.period : state.period;
    const selectedYear = period == undefined || ["Month", "Week", "Day"].includes(period)?new Date().getFullYear(): parseInt(period);

    const currentYear = new Date().getFullYear();

    state.comparisonGraph.data.push({
        name: currentYear.toString(),
        data: [],
        totals: 0,
        show: selectedYear == currentYear
    }, {
        name: (currentYear - 1).toString(),
        data: [],
        totals: 0,
        show: selectedYear == currentYear -1 || selectedYear == currentYear 
    }, {
        name: (currentYear - 2).toString(),
        data: [],
        totals: 0,
        show: selectedYear == currentYear -2 || selectedYear == currentYear - 1
    }, {
        name: (currentYear - 3).toString(),
        data: [],
        totals: 0,
        show: selectedYear == currentYear -3 || selectedYear == currentYear - 2
    });


    //For baskets as we need to separately calculate
    let basketValues: { year: number, total: number }[] = [{ year: 0, total: 0 }, { year: 0, total: 0 }, { year: 0, total: 0 }, { year: 0, total: 0 }];


    for (let storeIndex = 0; storeIndex < filteredStores.length; storeIndex++) {
        const store = filteredStores[storeIndex];

        if (store.response?.data) {

            let years: (Number | null)[] = [null, null, null, null];
            state.comparisonGraph.axis = store.response.data.salesOtc?.year3.axis ?? [];

            for (let index = 0; index < (store.response.data.salesOtc?.year3.values.length ?? 0); index++) {

                if (state.mainGraph === "Sales") {
                    years[0] = (store.response.data.salesOtc?.year3.values[index] ?? 0) +
                        (store.response.data.salesScript?.year3.values[index] ?? 0);

                    years[1] = (store.response.data.salesOtc?.year2.values[index] ?? 0) +
                        (store.response.data.salesScript?.year2.values[index] ?? 0);

                    years[2] = (store.response.data.salesOtc?.year1.values[index] ?? 0) +
                        (store.response.data.salesScript?.year1.values[index] ?? 0);

                    years[3] = (store.response.data.salesOtc?.year0.values[index] ?? 0) +
                        (store.response.data.salesScript?.year0.values[index] ?? 0);
                } else if (state.mainGraph === "Scripts") {

                    years[0] = (store.response.data.scriptsPaper?.year3.values[index] ?? 0) +
                        (store.response.data.scriptsPaperless?.year3.values[index] ?? 0) +
                        (store.response.data.scriptsOwing?.year3.values[index] ?? 0);

                    years[1] = (store.response.data.scriptsPaper?.year2.values[index] ?? 0) +
                        (store.response.data.scriptsPaperless?.year2.values[index] ?? 0) +
                        (store.response.data.scriptsOwing?.year2.values[index] ?? 0);

                    years[2] = (store.response.data.scriptsPaper?.year1.values[index] ?? 0) +
                        (store.response.data.scriptsPaperless?.year1.values[index] ?? 0) +
                        (store.response.data.scriptsOwing?.year1.values[index] ?? 0);

                    years[3] = (store.response.data.scriptsPaper?.year0.values[index] ?? 0) +
                        (store.response.data.scriptsPaperless?.year0.values[index] ?? 0) +
                        (store.response.data.scriptsOwing?.year0.values[index] ?? 0);

                } else if (state.mainGraph === "Profit") {
                    years[0] = (store.response.data.grossProfitOtc?.year3.values[index] ?? 0) +
                        (store.response.data.grossProfitScript?.year3.values[index] ?? 0);

                    years[1] = (store.response.data.grossProfitOtc?.year2.values[index] ?? 0) +
                        (store.response.data.grossProfitScript?.year2.values[index] ?? 0);

                    years[2] = (store.response.data.grossProfitOtc?.year1.values[index] ?? 0) +
                        (store.response.data.grossProfitScript?.year1.values[index] ?? 0);

                    years[3] = (store.response.data.grossProfitOtc?.year0.values[index] ?? 0) +
                        (store.response.data.grossProfitScript?.year0.values[index] ?? 0);

                } else if (state.mainGraph === "Refunds") {

                    state.comparisonGraph.axis = store.response.data.basketStatsOtc?.year3.axis ?? [];

                    for (let index = 0; index < (store.response.data.salesOtc?.year3.values.length ?? 0); index++) {

                        years[0] = (store.response.data.basketStatsRefunds?.year3.values[index] ?? 0);

                        years[1] = (store.response.data.basketStatsRefunds?.year2.values[index] ?? 0);

                        years[2] = (store.response.data.basketStatsRefunds?.year1.values[index] ?? 0);

                        years[3] = (store.response.data.basketStatsRefunds?.year0.values[index] ?? 0);
                    }
                } else if (state.mainGraph === "Basket") {
                    years[0] = (store.response.data.basketStatsOtc?.year3.values[index] ?? 0) +
                        (store.response.data.basketStatsScripts?.year3.values[index] ?? 0);

                    years[1] = (store.response.data.basketStatsOtc?.year2.values[index] ?? 0) +
                        (store.response.data.basketStatsScripts?.year2.values[index] ?? 0);


                    years[2] = (store.response.data.basketStatsOtc?.year1.values[index] ?? 0) +
                        (store.response.data.basketStatsScripts?.year1.values[index] ?? 0);

                    years[3] = (store.response.data.basketStatsOtc?.year0.values[index] ?? 0) +
                        (store.response.data.basketStatsScripts?.year0.values[index] ?? 0);


                    const yearsTotal = [
                        (store.response.data.basketStatsReceiptCount?.year3.values[index] ?? 0),
                        (store.response.data.basketStatsReceiptCount?.year2.values[index] ?? 0),
                        (store.response.data.basketStatsReceiptCount?.year1.values[index] ?? 0),
                        (store.response.data.basketStatsReceiptCount?.year0.values[index] ?? 0),
                    ]

                    for (let i = 0; i < 4; i++) {
                        //This clears the data for the current Month onwards since we don't want a drop to be visible in graphs
                        if (i == 0) {
                            years[i] = ApplyCutoffMainGraph(index, years[i] as number);
                        }

                        if (years[i] !== null) {
                            if (state.comparisonGraph.data[i].data[index] === undefined || state.comparisonGraph.data[i].data[index] === null)
                                state.comparisonGraph.data[i].data[index] = 0;

                            state.comparisonGraph.data[i].data[index]! += yearsTotal[i] > 0 ? years[i] as number / yearsTotal[i] : 0;
                            basketValues[i].year += years[i] as number;
                            basketValues[i].total += yearsTotal[i];
                        }
                    }

                    continue; //This skips the code below since we have custom logic instead

                }

                //Runs for all except basket which has its own logic and thus has a continue to skip this section
                for (let i = 0; i < 4; i++) {
                    //This clears the data for the current Month onwards since we don't want a drop to be visible in graphs
                    if (i == 0) {
                        years[i] = ApplyCutoffMainGraph(index, years[i] as number);
                    }

                    if (years[i] !== null) {
                        if (state.comparisonGraph.data[i].data[index] === undefined || state.comparisonGraph.data[i].data[index] === null)
                            state.comparisonGraph.data[i].data[index] = 0;

                        state.comparisonGraph.data[i].data[index]! += years[i] as number;
                    }
                }
            }



            //Totals calculation
            if (state.mainGraph === "Sales" || state.mainGraph === "Scripts" || state.mainGraph === "Profit" || state.mainGraph === "Refunds") {
                state.comparisonGraph.data[0].totals = Number((state.comparisonGraph.data[0].data.filter(p => p !== null).reduce((partialSum, a) => partialSum + a, 0)).toFixed(2));
                state.comparisonGraph.data[1].totals = Number((state.comparisonGraph.data[1].data.filter(p => p !== null).reduce((partialSum, a) => partialSum + a, 0)).toFixed(2));
                state.comparisonGraph.data[2].totals = Number((state.comparisonGraph.data[2].data.filter(p => p !== null).reduce((partialSum, a) => partialSum + a, 0)).toFixed(2));
                state.comparisonGraph.data[3].totals = Number((state.comparisonGraph.data[3].data.filter(p => p !== null).reduce((partialSum, a) => partialSum + a, 0)).toFixed(2));
            } else if (state.mainGraph === "Basket") {

                const calc = (data: number[], totals: []): number => {
                    const sum = data.reduce((partialSum, a) => partialSum + a, 0);
                    const total = totals.reduce((partialSum, a) => partialSum + a, 0);
                    return Number((sum / total).toFixed(2));
                }

                state.comparisonGraph.data[0].totals = Number((basketValues[0].total > 0 ? basketValues[0].year / basketValues[0].total : 0).toFixed(2));
                state.comparisonGraph.data[1].totals = Number((basketValues[1].total > 0 ? basketValues[1].year / basketValues[1].total : 0).toFixed(2));
                state.comparisonGraph.data[2].totals = Number((basketValues[2].total > 0 ? basketValues[2].year / basketValues[2].total : 0).toFixed(2));
                state.comparisonGraph.data[3].totals = Number((basketValues[3].total > 0 ? basketValues[3].year / basketValues[3].total : 0).toFixed(2));
            }
        }
    }
}

function CalculateCustomerData(state: StateType, action: any) {
    let filteredStores = state.storeData.stores.filter((i: any) => state.selectedStores.includes(i.storeId));

    //RESET!
    state.customerData = {
        ...initialState.customerData
    };


    for (let storeIndex = 0; storeIndex < filteredStores.length; storeIndex++) {
        const store = filteredStores[storeIndex];

        if (store.response?.data) {
            state.customerData.mobile += store.response.data.customerData?.mobile ?? 0;
            state.customerData.emails += store.response.data.customerData?.email ?? 0;
            state.customerData.birthdays += store.response.data.customerData?.dob ?? 0;
            state.customerData.activeTotal += store.response.data.customerData?.activeTotal ?? 0;

            state.customerData.aslConsent += store.response.data.customerData?.aslConsent ?? 0;
            state.customerData.scriptsOnFile += store.response.data.customerData?.repeatsHeld ?? 0;
        }
    }

    state.customerData.mobileGraph = state.customerData.activeTotal > 0 ? Math.round(state.customerData.mobile / state.customerData.activeTotal * 100) : 0;
    state.customerData.emailsGraph = state.customerData.activeTotal > 0 ? Math.round(state.customerData.emails / state.customerData.activeTotal * 100) : 0;
    state.customerData.birthdaysGraph = state.customerData.activeTotal > 0 ? Math.round(state.customerData.birthdays / state.customerData.activeTotal * 100) : 0;
    state.customerData.aslConsentGraph = state.customerData.activeTotal > 0 ? Math.round(state.customerData.aslConsent / state.customerData.activeTotal * 100) : 0;
    state.customerData.scriptsOnFileGraph = state.customerData.activeTotal > 0 ? Math.round(state.customerData.scriptsOnFile / state.customerData.activeTotal * 100) : 0;

}

function CalculateBasketStats(state: StateType, action: any) {

    let filteredStores = state.storeData.stores.filter((i: any) => state.selectedStores.includes(i.storeId));

    //RESET!
    state.basketStats = {
        total: 0,
        totalDollar: 0,
        otc: 0,
        otcDollar: 0,
        scripts: 0,
        scriptsDollar: 0,
        refunds: 0,
        refundsDollar: 0,
        count: 0,


        prevTotal: 0,
        prevTotalDollar: 0,
        prevOtc: 0,
        prevOtcDollar: 0,
        prevScripts: 0,
        prevScriptsDollar: 0,
        prevRefunds: 0,
        prevRefundsDollar: 0,
        prevCount: 0,

        message: ""
    }

    for (let storeIndex = 0; storeIndex < filteredStores.length; storeIndex++) {
        const store = filteredStores[storeIndex];

        const currentYear = new Date().getFullYear();

        if (store.response?.data) {
            if (state.period === currentYear.toString()) {
                state.basketStats.otc += store.response.data.basketStatsOtc?.year3.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.otcDollar += store.response.data.basketStatsOtcDollar?.year3.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.scripts += store.response.data.basketStatsScripts?.year3.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.scriptsDollar += store.response.data.basketStatsScriptsDollar?.year3.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.refunds += store.response.data.basketStatsRefunds?.year3.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.refundsDollar += store.response.data.basketStatsRefundsDollar?.year3.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.count += store.response.data.basketStatsReceiptCount?.year3.values.reduce((a, b) => a + b, 0) || 0;

                state.basketStats.prevOtc += store.response.data.basketStatsOtc?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevOtcDollar += store.response.data.basketStatsOtcDollar?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevScripts += store.response.data.basketStatsScripts?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevScriptsDollar += store.response.data.basketStatsScriptsDollar?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevRefunds += store.response.data.basketStatsRefunds?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevRefundsDollar += store.response.data.basketStatsRefundsDollar?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevCount += store.response.data.basketStatsReceiptCount?.year2.values.reduce((a, b) => a + b, 0) || 0;

                state.basketStats.message = "Since last year";
            } else if (state.period === (currentYear - 1).toString()) {
                state.basketStats.otc += store.response.data.basketStatsOtc?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.otcDollar += store.response.data.basketStatsOtcDollar?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.scripts += store.response.data.basketStatsScripts?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.scriptsDollar += store.response.data.basketStatsScriptsDollar?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.refunds += store.response.data.basketStatsRefunds?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.refundsDollar += store.response.data.basketStatsRefundsDollar?.year2.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.count += store.response.data.basketStatsReceiptCount?.year2.values.reduce((a, b) => a + b, 0) || 0;

                state.basketStats.prevOtc += store.response.data.basketStatsOtc?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevOtcDollar += store.response.data.basketStatsOtcDollar?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevScripts += store.response.data.basketStatsScripts?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevScriptsDollar += store.response.data.basketStatsScriptsDollar?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevRefunds += store.response.data.basketStatsRefunds?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevRefundsDollar += store.response.data.basketStatsRefundsDollar?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevCount += store.response.data.basketStatsReceiptCount?.year1.values.reduce((a, b) => a + b, 0) || 0;

                state.basketStats.message = "Since last year";
            } else if (state.period === (currentYear - 2).toString()) {
                state.basketStats.otc += store.response.data.basketStatsOtc?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.otcDollar += store.response.data.basketStatsOtcDollar?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.scripts += store.response.data.basketStatsScripts?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.scriptsDollar += store.response.data.basketStatsScriptsDollar?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.refunds += store.response.data.basketStatsRefunds?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.refundsDollar += store.response.data.basketStatsRefundsDollar?.year1.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.count += store.response.data.basketStatsReceiptCount?.year1.values.reduce((a, b) => a + b, 0) || 0;

                state.basketStats.prevOtc += store.response.data.basketStatsOtc?.year0.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevOtcDollar += store.response.data.basketStatsOtcDollar?.year0.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevScripts += store.response.data.basketStatsScripts?.year0.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevScriptsDollar += store.response.data.basketStatsScriptsDollar?.year0.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevRefunds += store.response.data.basketStatsRefunds?.year0.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevRefundsDollar += store.response.data.basketStatsRefundsDollar?.year0.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevCount += store.response.data.basketStatsReceiptCount?.year0.values.reduce((a, b) => a + b, 0) || 0;

                state.basketStats.message = "Since last year";
            } else if (state.period === "Month") {
                state.basketStats.otc += store.response.data.basketStatsOtc?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.otcDollar += store.response.data.basketStatsOtcDollar?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.scripts += store.response.data.basketStatsScripts?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.scriptsDollar += store.response.data.basketStatsScriptsDollar?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.refunds += store.response.data.basketStatsRefunds?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.refundsDollar += store.response.data.basketStatsRefundsDollar?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.count += store.response.data.basketStatsReceiptCount?.thisMonth.values.reduce((a, b) => a + b, 0) || 0;

                state.basketStats.prevOtc += store.response.data.basketStatsOtc?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevOtcDollar += store.response.data.basketStatsOtcDollar?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevScripts += store.response.data.basketStatsScripts?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevScriptsDollar += store.response.data.basketStatsScriptsDollar?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevRefunds += store.response.data.basketStatsRefunds?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevRefundsDollar += store.response.data.basketStatsRefundsDollar?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevCount += store.response.data.basketStatsReceiptCount?.lastMonth.values.reduce((a, b) => a + b, 0) || 0;

                state.basketStats.message = "Since last month";
            } else if (state.period === "Week") {
                state.basketStats.otc += store.response.data.basketStatsOtc?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.otcDollar += store.response.data.basketStatsOtcDollar?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.scripts += store.response.data.basketStatsScripts?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.scriptsDollar += store.response.data.basketStatsScriptsDollar?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.refunds += store.response.data.basketStatsRefunds?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.refundsDollar += store.response.data.basketStatsRefundsDollar?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.count += store.response.data.basketStatsReceiptCount?.thisWeek.values.reduce((a, b) => a + b, 0) || 0;

                state.basketStats.prevOtc += store.response.data.basketStatsOtc?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevOtcDollar += store.response.data.basketStatsOtcDollar?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevScripts += store.response.data.basketStatsScripts?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevScriptsDollar += store.response.data.basketStatsScriptsDollar?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevRefunds += store.response.data.basketStatsRefunds?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevRefundsDollar += store.response.data.basketStatsRefundsDollar?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevCount += store.response.data.basketStatsReceiptCount?.lastWeek.values.reduce((a, b) => a + b, 0) || 0;

                state.basketStats.message = "Since last week";
            } else if (state.period === "Day") {
                state.basketStats.otc += store.response.data.basketStatsOtc?.today.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.otcDollar += store.response.data.basketStatsOtcDollar?.today.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.scripts += store.response.data.basketStatsScripts?.today.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.scriptsDollar += store.response.data.basketStatsScriptsDollar?.today.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.refunds += store.response.data.basketStatsRefunds?.today.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.refundsDollar += store.response.data.basketStatsRefundsDollar?.today.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.count += store.response.data.basketStatsReceiptCount?.today.values.reduce((a, b) => a + b, 0) || 0;

                state.basketStats.prevOtc += store.response.data.basketStatsOtc?.yesterday.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevOtcDollar += store.response.data.basketStatsOtcDollar?.yesterday.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevScripts += store.response.data.basketStatsScripts?.yesterday.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevScriptsDollar += store.response.data.basketStatsScriptsDollar?.yesterday.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevRefunds += store.response.data.basketStatsRefunds?.yesterday.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevRefundsDollar += store.response.data.basketStatsRefundsDollar?.yesterday.values.reduce((a, b) => a + b, 0) || 0;
                state.basketStats.prevCount += store.response.data.basketStatsReceiptCount?.yesterday.values.reduce((a, b) => a + b, 0) || 0;

                state.basketStats.message = "Since yesterday";
            }

            state.basketStats.total = state.basketStats.count > 0 ? (state.basketStats.otc + state.basketStats.scripts) / state.basketStats.count : 0;
            state.basketStats.totalDollar = state.basketStats.count > 0 ? (state.basketStats.otcDollar + state.basketStats.scriptsDollar) / state.basketStats.count : 0;
            state.basketStats.prevTotal = state.basketStats.prevCount > 0 ? (state.basketStats.prevOtc + state.basketStats.prevScripts) / state.basketStats.prevCount : 0;
            state.basketStats.prevTotalDollar = state.basketStats.prevCount > 0 ? (state.basketStats.prevOtcDollar + state.basketStats.prevScriptsDollar) / state.basketStats.prevCount : 0;
        }
    }
}

function CalculateTotalGrossProfitGraph(state: StateType, action: any) {
    let filteredStores = state.storeData.stores.filter((i: any) => state.selectedStores.includes(i.storeId));

    //RESET!
    state.totalGrossProfitDrillDownGraph.axis = [];
    state.totalGrossProfitDrillDownGraph.data = [];

    const currentYear = new Date().getFullYear();

    filteredStores.forEach((store) => {
        let pharmacyData: {
            pharmacy: string,
            graphData: {
                year: string,
                data: number[],
                totals: number,
            }[],
        } = {
            pharmacy: store.storeName,
            graphData: []
        };

        for (let i = currentYear; i > currentYear - 4; i--) {
            pharmacyData.graphData.push({
                year: i.toString(),
                data: [],
                totals: 0
            });
        }

        state.totalGrossProfitDrillDownGraph.data.push(pharmacyData);
    });

    //For baskets as we need to separately calculate
    for (let storeIndex = 0; storeIndex < filteredStores.length; storeIndex++) {
        const store = filteredStores[storeIndex];

        const data = state.totalGrossProfitDrillDownGraph.data.find((i) => i.pharmacy === store.storeName);

        if (store.response?.data && data) {
            state.totalGrossProfitDrillDownGraph.axis = store.response.data.grossProfitOtc?.year3.axis ?? [];

            for (let index = 0; index < (store.response.data.grossProfitOtc?.year3.values.length ?? 0); index++) {
                const year3 = (store.response.data.grossProfitOtc?.year3.values[index] ?? 0) +
                    (store.response.data.grossProfitScript?.year3.values[index] ?? 0);

                const year2 = (store.response.data.grossProfitOtc?.year2.values[index] ?? 0) +
                    (store.response.data.grossProfitScript?.year2.values[index] ?? 0);

                const year1 = (store.response.data.grossProfitOtc?.year1.values[index] ?? 0) +
                    (store.response.data.grossProfitScript?.year1.values[index] ?? 0);

                const year0 = (store.response.data.grossProfitOtc?.year0.values[index] ?? 0) +
                    (store.response.data.grossProfitScript?.year0.values[index] ?? 0);

                data.graphData[0].data[index] = ApplyCutoffDrillDown(index, year3);
                data.graphData[1].data[index] = year2;
                data.graphData[2].data[index] = year1;
                data.graphData[3].data[index] = year0;
            }

            for (let i = 0; i < 4; i++) {
                data.graphData[i].totals = Number((data.graphData[i].data.filter(p => p !== null).reduce((partialSum, a) => partialSum + a, 0)).toFixed(2));
            }
        }
    }
}

function CalculateTotalSalesGraph(state: StateType, action: any) {
    let filteredStores = state.storeData.stores.filter((i: any) => state.selectedStores.includes(i.storeId));

    //RESET!
    state.totalSalesDrillDownGraph.axis = [];
    state.totalSalesDrillDownGraph.data = [];

    const currentYear = new Date().getFullYear();

    filteredStores.forEach((store) => {
        let pharmacyData: {
            pharmacy: string,
            graphData: {
                year: string,
                data: number[],
                totals: number,
            }[],
        } = {
            pharmacy: store.storeName,
            graphData: []
        };

        for (let i = currentYear; i > currentYear - 4; i--) {
            pharmacyData.graphData.push({
                year: i.toString(),
                data: [],
                totals: 0
            });
        }

        state.totalSalesDrillDownGraph.data.push(pharmacyData);
    });

    //For baskets as we need to separately calculate
    for (let storeIndex = 0; storeIndex < filteredStores.length; storeIndex++) {
        const store = filteredStores[storeIndex];

        const data = state.totalSalesDrillDownGraph.data.find((i) => i.pharmacy === store.storeName);

        if (store.response?.data && data) {
            state.totalSalesDrillDownGraph.axis = store.response.data.grossProfitOtc?.year3.axis ?? [];

            for (let index = 0; index < (store.response.data.grossProfitOtc?.year3.values.length ?? 0); index++) {
                const year3 = (store.response.data.scriptsPaper?.year3.values[index] ?? 0) +
                    (store.response.data.scriptsPaperless?.year3.values[index] ?? 0) +
                    (store.response.data.scriptsOwing?.year3.values[index] ?? 0);

                const year2 = (store.response.data.scriptsPaper?.year2.values[index] ?? 0) +
                    (store.response.data.scriptsPaperless?.year2.values[index] ?? 0) +
                    (store.response.data.scriptsOwing?.year2.values[index] ?? 0);

                const year1 = (store.response.data.scriptsPaper?.year1.values[index] ?? 0) +
                    (store.response.data.scriptsPaperless?.year1.values[index] ?? 0) +
                    (store.response.data.scriptsOwing?.year1.values[index] ?? 0);

                const year0 = (store.response.data.scriptsPaper?.year0.values[index] ?? 0) +
                    (store.response.data.scriptsPaperless?.year0.values[index] ?? 0) +
                    (store.response.data.scriptsOwing?.year0.values[index] ?? 0);

                data.graphData[0].data[index] = ApplyCutoffDrillDown(index, year3);
                data.graphData[1].data[index] = year2;
                data.graphData[2].data[index] = year1;
                data.graphData[3].data[index] = year0;
            }

            for (let i = 0; i < 4; i++) {
                data.graphData[i].totals = Number((data.graphData[i].data.filter(p => p !== null).reduce((partialSum, a) => partialSum + a, 0)).toFixed(2));
            }
        }
    }
}

function CalculateTotalScriptsGraph(state: StateType, action: any) {
    let filteredStores = state.storeData.stores.filter((i: any) => state.selectedStores.includes(i.storeId));

    //RESET!
    state.totalScriptsDrillDownGraph.axis = [];
    state.totalScriptsDrillDownGraph.data = [];

    const currentYear = new Date().getFullYear();

    filteredStores.forEach((store) => {
        let pharmacyData: {
            pharmacy: string,
            graphData: {
                year: string,
                data: number[],
                totals: number,
            }[],
        } = {
            pharmacy: store.storeName,
            graphData: []
        };

        for (let i = currentYear; i > currentYear - 4; i--) {
            pharmacyData.graphData.push({
                year: i.toString(),
                data: [],
                totals: 0
            });
        }

        state.totalScriptsDrillDownGraph.data.push(pharmacyData);
    });

    //For baskets as we need to separately calculate
    for (let storeIndex = 0; storeIndex < filteredStores.length; storeIndex++) {
        const store = filteredStores[storeIndex];

        const data = state.totalScriptsDrillDownGraph.data.find((i) => i.pharmacy === store.storeName);

        if (store.response?.data && data) {
            state.totalScriptsDrillDownGraph.axis = store.response.data.grossProfitOtc?.year3.axis ?? [];

            for (let index = 0; index < (store.response.data.grossProfitOtc?.year3.values.length ?? 0); index++) {
                const year3 = (store.response.data.salesOtc?.year3.values[index] ?? 0) +
                    (store.response.data.salesScript?.year3.values[index] ?? 0);

                const year2 = (store.response.data.salesOtc?.year2.values[index] ?? 0) +
                    (store.response.data.salesScript?.year2.values[index] ?? 0);

                const year1 = (store.response.data.salesOtc?.year1.values[index] ?? 0) +
                    (store.response.data.salesScript?.year1.values[index] ?? 0);

                const year0 = (store.response.data.salesOtc?.year0.values[index] ?? 0) +
                    (store.response.data.salesScript?.year0.values[index] ?? 0);

                data.graphData[0].data[index] = ApplyCutoffDrillDown(index, year3);
                data.graphData[1].data[index] = year2;
                data.graphData[2].data[index] = year1;
                data.graphData[3].data[index] = year0;
            }

            for (let i = 0; i < 4; i++) {
                data.graphData[i].totals = Number((data.graphData[i].data.filter(p => p !== null).reduce((partialSum, a) => partialSum + a, 0)).toFixed(2));
            }
        }
    }
}

function CalculateAverageBasketGraph(state: StateType, action: any) {
    let filteredStores = state.storeData.stores.filter((i: any) => state.selectedStores.includes(i.storeId));

    //RESET!
    state.totalDrillDownBasketGraph.axis = [];
    state.totalDrillDownBasketGraph.data = [];

    const currentYear = new Date().getFullYear();

    filteredStores.forEach((store) => {
        let pharmacyData: {
            pharmacy: string,
            graphData: {
                year: string,
                data: number[],
                totals: number,
            }[],
        } = {
            pharmacy: store.storeName,
            graphData: []
        };

        for (let i = currentYear; i > currentYear - 4; i--) {
            pharmacyData.graphData.push({
                year: i.toString(),
                data: [],
                totals: 0
            });
        }

        state.totalDrillDownBasketGraph.data.push(pharmacyData);
    });

    //For baskets as we need to separately calculate
    for (let storeIndex = 0; storeIndex < filteredStores.length; storeIndex++) {
        const store = filteredStores[storeIndex];

        const data = state.totalDrillDownBasketGraph.data.find((i) => i.pharmacy === store.storeName);

        if (store.response?.data && data) {
            state.totalDrillDownBasketGraph.axis = store.response.data.grossProfitOtc?.year3.axis ?? [];

            for (let index = 0; index < (store.response.data.grossProfitOtc?.year3.values.length ?? 0); index++) {
                const year3 = (store.response.data.basketStatsOtc?.year3.values[index] ?? 0) +
                    (store.response.data.basketStatsScripts?.year3.values[index] ?? 0);

                const year2 = (store.response.data.basketStatsOtc?.year2.values[index] ?? 0) +
                    (store.response.data.basketStatsScripts?.year2.values[index] ?? 0);


                const year1 = (store.response.data.basketStatsOtc?.year1.values[index] ?? 0) +
                    (store.response.data.basketStatsScripts?.year1.values[index] ?? 0);

                const year0 = (store.response.data.basketStatsOtc?.year0.values[index] ?? 0) +
                    (store.response.data.basketStatsScripts?.year0.values[index] ?? 0);

                //Index is the month, but if its < this month, then we'll include it, otherwise we'll ignore it
                data.graphData[0].data[index] = ApplyCutoffDrillDown(index, year3);
                data.graphData[1].data[index] = year2;
                data.graphData[2].data[index] = year1;
                data.graphData[3].data[index] = year0;
            }

            for (let i = 0; i < 4; i++) {
                data.graphData[i].totals = Number((data.graphData[i].data.filter(p => p !== null).reduce((partialSum, a) => partialSum + a, 0)).toFixed(2));
            }
        }
    }
}

function CalculateDrillDownReport(state: StateType, action: any) {
    let filteredStores = state.storeData.stores.filter((i: any) => state.selectedStores.includes(i.storeId));

    //RESET!
    state.drillDownGraph.axis = [];
    state.drillDownGraph.data = [];

    const currentYear = new Date().getFullYear();


    for (let storeIndex = 0; storeIndex < filteredStores.length; storeIndex++) {
        const store = filteredStores[storeIndex];


        let pharmacyData: {
            pharmacy: string,
            id: number,
            graphData: {
                name: string,
                data: (number | null)[],
                totals: number,
                group: string,
            }[],
        } = {
            pharmacy: store.storeName,
            id: store.storeId,
            graphData: []
        };
        state.drillDownGraph.data.push(pharmacyData);

        if (store.response?.data) {

            let years: (Number | null)[] = [null, null, null, null];
            state.drillDownGraph.axis = store.response.data.salesOtc?.year3.axis ?? [];

            let groups: {
                data: number[],
                name: string
            }[] = [];

            if (state.drillDownGraphType === "Sales") {
                groups[0] = { name: 'OTC Sales', data: store.response.data.salesOtc.year0.values.concat(store.response.data.salesOtc.year1.values).concat(store.response.data.salesOtc.year2.values).concat(store.response.data.salesOtc.year3.values) };
                groups[1] = { name: 'Script Sales', data: store.response.data.salesScript.year0.values.concat(store.response.data.salesScript.year1.values).concat(store.response.data.salesScript.year2.values).concat(store.response.data.salesScript.year3.values) };
            } else if (state.drillDownGraphType === "Scripts") {
                groups[0] = { name: 'Paper', data: store.response.data.scriptsPaper.year0.values.concat(store.response.data.scriptsPaper.year1.values).concat(store.response.data.scriptsPaper.year2.values).concat(store.response.data.scriptsPaper.year3.values) };
                groups[1] = { name: 'Paperless', data: store.response.data.scriptsPaperless.year0.values.concat(store.response.data.scriptsPaperless.year1.values).concat(store.response.data.scriptsPaperless.year2.values).concat(store.response.data.scriptsPaperless.year3.values) };
                groups[2] = { name: 'Owing', data: store.response.data.scriptsOwing.year0.values.concat(store.response.data.scriptsOwing.year1.values).concat(store.response.data.scriptsOwing.year2.values).concat(store.response.data.scriptsOwing.year3.values) };
            } else if (state.drillDownGraphType === "Profit") {
                groups[0] = { name: 'OTC', data: store.response.data.grossProfitOtc.year0.values.concat(store.response.data.grossProfitOtc.year1.values).concat(store.response.data.grossProfitOtc.year2.values).concat(store.response.data.grossProfitOtc.year3.values) };
                groups[1] = { name: 'Scripts', data: store.response.data.grossProfitScript.year0.values.concat(store.response.data.grossProfitScript.year1.values).concat(store.response.data.grossProfitScript.year2.values).concat(store.response.data.grossProfitScript.year3.values) };
            } else if (state.drillDownGraphType === "Refunds") {
                groups[0] = { name: 'Refunds', data: store.response.data.basketStatsRefunds.year0.values.concat(store.response.data.basketStatsRefunds.year1.values).concat(store.response.data.basketStatsRefunds.year2.values).concat(store.response.data.basketStatsRefunds.year3.values) };
            } else if (state.drillDownGraphType === "Basket") {
                groups[0] = { name: 'OTC', data: store.response.data.basketStatsOtc.year0.values.concat(store.response.data.basketStatsOtc.year1.values).concat(store.response.data.basketStatsOtc.year2.values).concat(store.response.data.basketStatsOtc.year3.values) };
                groups[1] = { name: 'Scripts', data: store.response.data.basketStatsScripts.year0.values.concat(store.response.data.basketStatsScripts.year1.values).concat(store.response.data.basketStatsScripts.year2.values).concat(store.response.data.basketStatsScripts.year3.values) };
                let totals = { name: 'Totals', data: store.response.data.basketStatsReceiptCount.year0.values.concat(store.response.data.basketStatsReceiptCount.year1.values).concat(store.response.data.basketStatsReceiptCount.year2.values).concat(store.response.data.basketStatsReceiptCount.year3.values) };

                groups.forEach((group, index) => {
                    pharmacyData.graphData.push({
                        data: group.data.map((value, index) => {
                            let val =(index - 36 < 0 ? value : ApplyCutoffDrillDown(index % 12, value));
                            if (val !== null && totals.data[index] !== null && totals.data[index] !== 0) {
                                return val / totals.data[index];
                            }
                            return null;
                        }),
                        name: pharmacyData.pharmacy,
                        totals: Number((group.data.filter(p => p !== null).reduce((partialSum, a) => partialSum + a, 0)).toFixed(2)),
                        group: group.name
                    });
                });

                continue;
            }


            groups.forEach((group, index) => {
                pharmacyData.graphData.push({
                    data: group.data.map((value, index) => (index - 36 < 0 ? value : ApplyCutoffDrillDown(index % 12, value))),
                    name: pharmacyData.pharmacy,
                    totals: Number((group.data.filter(p => p !== null).reduce((partialSum, a) => partialSum + a, 0)).toFixed(2)),
                    group: group.name
                });
            });
        }
    }
}

function CalculateQuickStats(state: StateType, action: any) {
    let filteredStores = state.storeData.stores.filter((i: any) => state.selectedStores.includes(i.storeId));

    //RESET!
    state.quickStatAmounts = {
        stockValue: 0,
        negativeStockCount: 0,
    };


    for (let storeIndex = 0; storeIndex < filteredStores.length; storeIndex++) {
        const store = filteredStores[storeIndex];
        
        if (store.response?.data) {
            state.quickStatAmounts.stockValue += store.response.data.quickStatAmounts?.stockValue ?? 0;
            state.quickStatAmounts.negativeStockCount += store.response.data.quickStatAmounts?.negativeSOH ?? 0;
        }
    }
}


function AddTogether(arrays: number[][]): number[] {

    let result: number[] = [];

    for (let index = 0; index < arrays.length; index++) {
        const parent = arrays[index];

        for (let child = 0; child < parent.length; child++) {
            if (result[child] === undefined) result[child] = 0;

            result[child] += parent[index];
        }
    }

    return result;
}

function AddArrays(arrays: number[]): number {

    let result: number = 0;
    
    
    for (let index = 0; index < arrays.length; index++) {
        result += arrays[index];
    }
   
    return result;
}


export type StateType = {
    loading: boolean,
    storeData: ServerResponse<DataResponse<DashboardData>>,
    selectedStores: number[],
    period: string,
    mainGraph: string,
    topSales: {
        name: string,
        value: number
    }[]
    topSalesMax: number,

    sales: {
        otc: number,
        script: number,
        total: number,

        prevOtc: number,
        prevScript: number,
        prevTotal: number,

        message: string,
    },
    scripts: {
        paper: number,
        paperless: number,
        owing: number,
        total: number,

        prevPaper: number,
        prevPaperless: number,
        prevOwing: number,
        prevTotal: number

        message: string
    },
    grossProfit: {
        otc: number,
        script: number,
        total: number,

        prevOtc: number,
        prevScript: number,
        prevTotal: number

        message: string
    },
    basket: {
        otc: number,
        script: number,
        total: number,

        prevOtc: number,
        prevScript: number,
        prevTotal: number

        message: string
    },
    preferredBrand: {
        count: number,
        total: number,
        moneyLost: number,

        prevCount: number,
        prevTotal: number,
        prevMoneyLost: number,

        message: string[],
        middle: string[],
    },

    comparisonGraph: {
        data: {
            name: string,
            data: (number | null)[],
            totals: number,
            show: boolean
        }[],
        axis: string[],
        other?: any
    },

    customerData: {
        activeTotal: number,
        mobile: number,
        emails: number,
        birthdays: number,
        aslConsent: number,
        scriptsOnFile: number,

        mobileGraph: number,
        emailsGraph: number,
        birthdaysGraph: number,
        aslConsentGraph: number,
        scriptsOnFileGraph: number
    },

    basketStats: {
        total: number,
        totalDollar: number,
        otc: number,
        otcDollar: number,
        scripts: number,
        scriptsDollar: number,
        refunds: number,
        refundsDollar: number,
        count: number,

        prevTotal: number,
        prevTotalDollar: number,
        prevOtc: number,
        prevOtcDollar: number,
        prevScripts: number,
        prevScriptsDollar: number,
        prevRefunds: number,
        prevRefundsDollar: number,
        prevCount: number,

        message: string,
    },

    selectedYear: any,


    totalGrossProfitDrillDownGraph: {
        data: {
            pharmacy: string,
            graphData: {
                year: string,
                data: (number | null)[],
                totals: number,
            }[],
        }[],
        axis: string[],
        other?: any,
    },

    totalSalesDrillDownGraph: {
        data: {
            pharmacy: string,
            graphData: {
                year: string,
                data: (number | null)[],
                totals: number,
            }[],
        }[],
        axis: string[],
        other?: any,
    },

    totalScriptsDrillDownGraph: {
        data: {
            pharmacy: string,
            graphData: {
                year: string,
                data: (number | null)[],
                totals: number,
            }[],
        }[],
        axis: string[],
        other?: any,
    },

    totalDrillDownBasketGraph: {
        data: {
            pharmacy: string,
            graphData: {
                year: string,
                data: (number | null)[],
                totals: number,
            }[],
        }[],
        axis: string[],
        other?: any,
    },





    drillDownGraph: {
        data: {
            pharmacy: string,
            id: number,
            graphData: {
                name: string,
                data: (number | null)[],
                totals: number,
                group: string,
            }[],
        }[],
        axis: string[],
        other?: any,
    },
    drillDownGraphType: string,


    quickStatAmounts: {
        stockValue: number,
        negativeStockCount: number,
    },
}

const initialState: StateType = {
    loading: false,
    selectedStores: [],
    storeData: {
        stores: [],
        errors: []
    },

    topSales: [],
    topSalesMax: 0,

    period: new Date().getFullYear().toString(),
    mainGraph: "Sales",

    sales: {
        otc: 0,
        script: 0,
        total: 0,

        prevOtc: 0,
        prevScript: 0,
        prevTotal: 0,

        message: "",
    },
    scripts: {
        paper: 0,
        paperless: 0,
        owing: 0,
        total: 0,

        prevPaper: 0,
        prevPaperless: 0,
        prevOwing: 0,
        prevTotal: 0,

        message: ""
    },
    grossProfit: {
        otc: 0,
        script: 0,
        total: 0,

        prevOtc: 0,
        prevScript: 0,
        prevTotal: 0,

        message: ""
    },
    basket: {
        otc: 0,
        script: 0,
        total: 0,

        prevOtc: 0,
        prevScript: 0,
        prevTotal: 0,

        message: ""
    },
    preferredBrand: {
        count: 0,
        total: 0,
        moneyLost: 0,

        prevCount: 0,
        prevTotal: 0,
        prevMoneyLost: 0,

        message: [],
        middle: [],
    },

    comparisonGraph: {
        data: [],
        axis: [],
    },

    customerData: {
        mobile: 0,
        emails: 0,
        birthdays: 0,
        activeTotal: 0,

        mobileGraph: 0,
        emailsGraph: 0,
        birthdaysGraph: 0,


        aslConsent: 0,
        scriptsOnFile: 0,

        aslConsentGraph: 0,
        scriptsOnFileGraph: 0,
    },

    basketStats: {
        total: 0,
        totalDollar: 0,
        otc: 0,
        otcDollar: 0,
        scripts: 0,
        scriptsDollar: 0,
        refunds: 0,
        refundsDollar: 0,
        count: 0,

        prevTotal: 0,
        prevTotalDollar: 0,
        prevOtc: 0,
        prevOtcDollar: 0,
        prevScripts: 0,
        prevScriptsDollar: 0,
        prevRefunds: 0,
        prevRefundsDollar: 0,
        prevCount: 0,

        message: "",
    },

    selectedYear: {},

    totalGrossProfitDrillDownGraph: {
        data: [],
        axis: [],
    },

    totalSalesDrillDownGraph: {
        data: [],
        axis: [],
    },

    totalScriptsDrillDownGraph: {
        data: [],
        axis: [],
    },

    totalDrillDownBasketGraph: {
        data: [],
        axis: [],
    },


    drillDownGraph: {
        data: [],
        axis: [],
    },
    drillDownGraphType: "Sales",


    quickStatAmounts: {
        stockValue: 0,
        negativeStockCount: 0,
    },
};

function UpdateAll(state: any, action: any) {
    CalculateSales(state, action);
    CalculateScripts(state, action);
    CalculateGrossProfit(state, action);

    CalclatePreferredBrand(state, action);

    CalculateMainGraph(state, action);

    CalculateCustomerData(state, action);
    CalculateBasketStats(state, action);

    CalculateTotalGrossProfitGraph(state, action);
    CalculateTotalSalesGraph(state, action);
    CalculateAverageBasketGraph(state, action);
    CalculateTotalScriptsGraph(state, action);


    CalculateDrillDownReport(state, action);
    CalculateQuickStats(state, action);
}

const dasboardSlice = createSlice({
    name: "dashboardSlice",
    initialState: initialState,
    reducers: {
        updateField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
        updateTimestampTotals: (state, action) => {
            UpdateAll(state, action);
        },
        updatePeriod: (state, action) => {
            state.period = action.payload.period;
            UpdateAll(state, action);
        },
        updateStores: (state, action) => {
            state.selectedStores = action.payload.stores;
            UpdateAll(state, action);
        },
        updateMainGraph: (state, action) => {
            state.mainGraph = action.payload.mainGraph;
            state.drillDownGraphType = action.payload.mainGraph;
            UpdateAll(state, action);
        },
        updateDrillDown: (state, action) => {
            state.drillDownGraphType = action.payload.drillDownGraphType;
            UpdateAll(state, action);
        },
        updateAll: (state, action) => {
            UpdateAll(state, action);
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getDashboardStores.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getDashboardStores.fulfilled, (state, action) => {
            state.storeData = action.payload;
            state.loading = false;
        });
    }
});

export const { updateField, updateTimestampTotals, updatePeriod, updateMainGraph, updateStores, updateAll, updateDrillDown } = dasboardSlice.actions;

export default dasboardSlice.reducer;